import { useCallback } from "react";
import { VALUE_LEFT, VALUE_RIGHT } from "keycode-js";
import useNav from "./useNav";
import ViewerEvent from "../../api/core/ViewerEvent";
import { isModalOpen } from "../../../../../common/ui/vstui-helpers";
import useGlobalEvent from "../events/useGlobalEvent";
import useIsSnippet from "../viewer/useIsSnippet";
import useLastPage from "../last-page/useLastPage";
import { useBrand } from "../../../../../common/providers/brand/brand-context";

function hasModifierKey(event) {
  return event.ctrlKey || event.altKey || event.shiftKey || event.metaKey;
}

function isSuppressedTarget(event) {
  const attributes = event.target.attributes;
  const role = attributes?.role?.value;
  return (
    ["INPUT", "TEXTAREA"].indexOf(event.target.nodeName.toUpperCase()) >= 0 ||
    role === "tab" ||
    // is a separator that is interactive (cf. ResizerLine)
    (role === "separator" && attributes?.["aria-valuemax"]?.value)
  );
}

export default function useKeyboardShortcuts() {
  const nav = useNav();
  const isSnippet = useIsSnippet();
  const { lastPage, toggleLastPage } = useLastPage();
  const brand = useBrand();

  const keyHandler = useCallback(
    (incomingEvent) => {
      if (isSuppressedTarget(incomingEvent) || isModalOpen()) {
        return;
      }
      if (!isSnippet && brand.getProp("CoreNavigation.enabled")) {
        if (
          incomingEvent.key === VALUE_RIGHT &&
          !hasModifierKey(incomingEvent)
        ) {
          nav.handleGoToNextPage();
        } else if (
          incomingEvent.key === VALUE_LEFT &&
          !hasModifierKey(incomingEvent)
        ) {
          nav.handleGoToPrevPage();
        } else if (
          lastPage &&
          incomingEvent.key === "J" &&
          incomingEvent.shiftKey
        ) {
          toggleLastPage();
        }
      }
    },
    [isSnippet, lastPage, nav, toggleLastPage, brand]
  );

  useGlobalEvent(ViewerEvent.KEYUP, keyHandler);
}
